var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.25 9a2.5 2.5 0 1 0-2.196-1.305l-4.186 5.382a2.5 2.5 0 0 0-1.783.21l-1.42-1.136A2.503 2.503 0 0 0 9.25 9a2.5 2.5 0 0 0-2.328 3.414l-2.758 2.758a2.5 2.5 0 1 0 1.414 1.414l2.758-2.758c.283.111.592.172.914.172.42 0 .817-.104 1.165-.287l1.42 1.136A2.503 2.503 0 0 0 14.25 18a2.5 2.5 0 0 0 2.196-3.695l4.186-5.382Q20.93 9 21.25 9m0-2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-12 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m11.5-2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0",
  clipRule: "evenodd"
})));
export default SvgIconGraph;